module.exports = __webpack_public_path__ + "media/images/landing/second/photo1-5ab96153d6e0781c025e0a28582af08c.jpg";